import React, { useState } from "react";
import styled from "styled-components";
import SettingsLayout from "../../../layouts/SettingsLayout";
import RecruiterUser from "../../../../apiResources/RecruiterUser";
import Recruiter from "../../../../apiResources/Recruiter";
import EmployerUser from "../../../../apiResources/EmployerUser";
import Employer from "../../../../apiResources/Employer";
import SettingsHeading from "../../../settings/SettingsHeading";
import NameSettingOption from "../../../settings/NameSettingOption";
import EmailSettingOption from "../../../settings/EmailSettingOption";
import MobileNumberSettingOption from "../../../settings/MobileNumberSettingOption";
import PasswordSettingOption from "../../../settings/PasswordSettingOption";
import PhotoSettingOption from "../../../settings/PhotoSettingOption";
import JobTitleSettingOption from "../../../settings/JobTitleSettingOption";
import LinkedInSettingOption from "../../../settings/LinkedInSettingOption";
import TwitterSettingOption from "../../../settings/TwitterSettingOption";
import BiographySettingOption from "../../../settings/BiographySettingOption";
import Divider from "../../../library/Divider";
import Loader from "../../../library/Loader";

const Details = (props: Props) => {
  const { user, company } = props;

  const [editFocus, setEditFocus] = useState<string>(null);
  const resetEditFocus = () => setEditFocus(null);

  const isEditing = (key) => Boolean(editFocus) && editFocus === key;
  const isDisabled = (key) => Boolean(editFocus) && editFocus !== key;

  if (!user) {
    return (
      <SettingsLayout>
        <Loader />
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout user={user} company={company}>
      <SettingsHeading>Personal Info</SettingsHeading>
      <OptionsList>
        <NameSettingOption
          user={user}
          isEditing={isEditing("name")}
          disabled={isDisabled("name")}
          onEdit={() => setEditFocus("name")}
          onDone={resetEditFocus}
        />
        <Divider />
        <EmailSettingOption
          user={user}
          isEditing={isEditing("email")}
          disabled={isDisabled("email")}
          onEdit={() => setEditFocus("email")}
          onDone={resetEditFocus}
        />
        <Divider />
        <PhotoSettingOption
          user={user}
          isEditing={isEditing("photo")}
          disabled={isDisabled("photo")}
          onEdit={() => setEditFocus("photo")}
          onDone={resetEditFocus}
        />
        <Divider />
        <PasswordSettingOption
          user={user}
          isEditing={isEditing("password")}
          disabled={isDisabled("password")}
          onEdit={() => setEditFocus("password")}
          onDone={resetEditFocus}
        />
        <Divider />
        <MobileNumberSettingOption
          user={user}
          isEditing={isEditing("mobileNumber")}
          disabled={isDisabled("mobileNumber")}
          onEdit={() => setEditFocus("mobileNumber")}
          onDone={resetEditFocus}
        />
        <Divider />
        {user.isEmployer && (
          <>
            <JobTitleSettingOption
              user={user as EmployerUser}
              isEditing={isEditing("jobTitle")}
              disabled={isDisabled("jobTitle")}
              onEdit={() => setEditFocus("jobTitle")}
              onDone={resetEditFocus}
            />
            <Divider />
            <LinkedInSettingOption
              user={user as EmployerUser}
              isEditing={isEditing("linkedIn")}
              disabled={isDisabled("linkedIn")}
              onEdit={() => setEditFocus("linkedIn")}
              onDone={resetEditFocus}
            />
            <Divider />
            <TwitterSettingOption
              user={user as EmployerUser}
              isEditing={isEditing("twitter")}
              disabled={isDisabled("twitter")}
              onEdit={() => setEditFocus("twitter")}
              onDone={resetEditFocus}
            />
            <Divider />
            <BiographySettingOption
              user={user as EmployerUser}
              isEditing={isEditing("biography")}
              disabled={isDisabled("biography")}
              onEdit={() => setEditFocus("biography")}
              onDone={resetEditFocus}
            />
          </>
        )}
      </OptionsList>
    </SettingsLayout>
  );
};

type Props = {
  user: RecruiterUser | EmployerUser;
  company: Employer | Recruiter;
};

const OptionsList = styled.div`
  max-width: 100%;
`;

export default Details;
